<script>
  import { External } from '../../../external';
  import { onMount } from 'svelte';
  export let imageDetails,
    imageSrc = '',
    showDelete = false,
    onDelete = () => {};
  let isProcessing = false;
  const getThumbnailSrc = () => {
    return External.getThumbnailsFromBase(imageDetails.base + '/', '640x480') + imageDetails.name + '?format=webp';
  };
  const getImageSrc = () => {
    return External.getFileFromBase(imageDetails.base + '/') + imageDetails.name + '?format=webp';
  };
  const warmImage = (imageUrl) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve();
      };
      img.onerror = () => {
        setTimeout(() => {
          warmImage(imageUrl).then(resolve);
        }, 500);
      };
      img.src = imageUrl;
    });
  };
  const imageRendered = () => {
    External.WebPlatform.refreshLightboxes();
  };
  onMount(async () => {
    if (imageDetails) {
      isProcessing = true;
      await warmImage(getThumbnailSrc());
      isProcessing = false;
    }
  });
</script>
<div
  data-rel="lightbox"
  class="comment-image-wrapper">
  {#if imageSrc}
    <img
      on:load={imageRendered}
      data-slide={`${imageSrc}`}
      data-idx="0"
      src={imageSrc} />
  {:else if imageDetails && isProcessing}
    <div
      class="checkout-spinner-wrapper t-center checkout-spinner-wrapper-small"
      style="background: #E5E7F0;border-radius: 8px;width: 150px;height: 80px;">
      <div
        class="checkout-spinner"
        style="position: absolute;top: 50%;margin-top: -14px;left: 50%;margin-left: -14px; width:25px; height:25px;">
      </div>
    </div>
  {:else}
    <img
      on:load={imageRendered}
      data-slide={`${getImageSrc()}`}
      data-idx="0"
      style="max-width: 100%;"
      src={getThumbnailSrc()} />
  {/if}
  {#if showDelete}
    <div
      on:click={onDelete}
      class="circle-round-btn circle-effect f-left"
      style="position: absolute;right: -50px;top: 50%;margin-top: -14px;">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
        <path
          d="M292.309-140.001q-29.923 0-51.115-21.193-21.193-21.192-21.193-51.115V-720h-40v-59.999H360v-35.384h240v35.384h179.999V-720h-40v507.691q0 30.308-21 51.308t-51.308 21H292.309ZM680-720H280v507.691q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462h375.382q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463V-720ZM376.155-280h59.999v-360h-59.999v360Zm147.691 0h59.999v-360h-59.999v360ZM280-720v520-520Z"
        ></path>
      </svg>
    </div>
  {/if}
</div>
